import React from 'react';
//import Dashboard from '../components/Dashboard/Dashboard';

const HistoryPage = () => {
  return <div>History Page</div>; 
};

export default HistoryPage;
